import PageHeader from "@/components/molecules/PageHeader";
import { router } from "@inertiajs/react";
import Container from "@/components/atoms/Container";
import NoticeForm from "@/components/organisms/Notice/Form";
import useMessageProps from "@/hooks/useMessageProps";

export type FormFieldProps = {
  name: string;
  label: string;
  description?: string;
  placeholder?: string;
};

const NewNotice = (props: any) => {
  useMessageProps(props);

  const onSubmit = (data: any) => {
    router.post("/notices", data);
  };

  return (
    <Container>
      <PageHeader title="New Notice" />
      <NoticeForm
        edit={true}
        notice={null}
        onSubmit={onSubmit}
        mode="create"
        errors={props.errors}
      />
    </Container>
  );
};

export default NewNotice;
